var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberHomes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NUMBER_of_HOMES",
    "data-name": "NUMBER of HOMES",
    transform: "translate(-455 -352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4276",
    "data-name": "Rectangle 4276",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 352)",
    fill: "#fffae8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home_1_",
    "data-name": "home (1)",
    d: "M11.484,32.381v-5.29a2.46,2.46,0,0,1,2.456-2.448h4.978a2.46,2.46,0,0,1,2.473,2.448h0V32.4a2.113,2.113,0,0,0,2.074,2.1h3.319a5.961,5.961,0,0,0,5.991-5.931h0V13.52a4.208,4.208,0,0,0-1.659-3.286L19.765,1.182a5.486,5.486,0,0,0-6.8,0l-11.3,9.069A4.175,4.175,0,0,0,0,13.537V28.569A5.961,5.961,0,0,0,5.991,34.5H9.31a2.13,2.13,0,0,0,2.141-2.119h0",
    transform: "translate(485.5 381.5)",
    fill: "none",
    stroke: "#bf9200",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberHomes);
export default __webpack_public_path__ + "static/media/NUMBER-HOMES.21ccd4a08d885e6d12bc63b1d4e24655.svg";
export { ForwardRef as ReactComponent };